import React, { useState, useEffect, useCallback } from "react";

import PropTypes from 'prop-types';

import {
	Tabs,
	Tab,
	Box,
	Card,
	Link,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	DialogContentText,
	LinearProgress,
	Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { withLocalize, Translate } from 'react-localize-redux';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import Format from 'date-fns/format';

import axios from "axios";
import MUIDataTable from 'mui-datatables';

import {
	FinanceService,
	AdminService,
} from '../../utils/web_config.jsx';
import { useAuthUser } from "../../hooks/useUserToken.js";
import DateFnsUtils from '@date-io/date-fns';
CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function transformCardData(data) {
	if (!Array.isArray(data)) {
		throw new Error('Input should be an array.');
	}

	// Initialize result object
	const result = {
		total: 0,
		disabled: 0,
		enabled: 0,
		cards_value: 0,
	};

	// Process the input array
	data.forEach((entry) => {
		if (entry.status === 'ENABLED') {
			result.enabled += entry.total_cards || 0;
		} else if (entry.status === 'DISABLED') {
			result.disabled += entry.total_cards || 0;
		}

		result.cards_value += parseFloat(entry.total_balance || 0);
	});

	// Calculate the total number of cards
	result.total = result.enabled + result.disabled;

	return [result];
}

function transformCardData2(data) {
	const outputObject = data.reduce(
		(acc, item) => {
			const key = item.payment_mode.toLowerCase(); // Convert payment_mode to lowercase
			acc[key] = item.total_amount;
			acc.total += item.total_amount;
			return acc;
		},
		{ card: 0, promotion: 0, topup: 0, total: 0 }
	); // Initialize with default values

	return [outputObject];
}

function CardStatus({ startDate, endDate }) {
	const authUser = useAuthUser();

	const [cardStatusLevel1, setCardStatusLevel1] = useState([]);
	const [activeStatus, setActiveStatus] = useState(null);
	const [accounts, setAccounts] = useState([]);

	const [loadingCardStatus, setLoadingCardStatus] = useState(false);
	const [loadingAccounts, setLoadingAccounts] = useState(false);

	useEffect(() => {
		const loyalCardsInstance = axios.create(
			new AdminService().getHeaders(authUser.token)
		);

		setLoadingCardStatus(true);
		loyalCardsInstance
			.get(
				new FinanceService().GET_CARD_SUMMARY +
					'?organization_id=' +
					authUser.organization.organization_id
			)
			.then((res) => {
				setCardStatusLevel1(transformCardData(res.data.data));
			})
			.finally(() => {
				setLoadingCardStatus(false);
			});
	}, []);

	useEffect(() => {
		if (!activeStatus) return;

		const status = activeStatus == 'ALL' ? '' : activeStatus;

		const loyalCardsInstance = axios.create(
			new AdminService().getHeaders(authUser.token)
		);

		setLoadingAccounts(true);
		loyalCardsInstance
			.get(
				new FinanceService().GET_ALL_ACCOUNTS +
					'?organization_id=' +
					authUser.organization.organization_id +
					'&status=' +
					status +
					'&per_page=' +
					cardStatusLevel1[0].total || 1000
			)
			.then((res) => {
				setAccounts(res.data.data);
			})
			.finally(() => {
				setLoadingAccounts(false);
			});
	}, [activeStatus]);

	return (
		<div>
			{loadingCardStatus && <LinearProgress />}
			<MUIDataTable
				title={'Accounts'}
				data={cardStatusLevel1}
				columns={[
					{
						name: 'total',
						label: 'Accounts',
						options: {
							filter: true,
							sort: false,
							customBodyRender: (value) => {
								return (
									<Link
										onClick={() => setActiveStatus('ALL')}
										style={{ cursor: 'pointer' }}
									>
										{value}
									</Link>
								);
							},
						},
					},
					{
						name: 'enabled',
						label: 'Enabled',
						options: {
							customBodyRender: (value) => {
								return (
									<Link
										onClick={() => setActiveStatus('ENABLED')}
										style={{ cursor: 'pointer' }}
									>
										{value}
									</Link>
								);
							},
						},
					},
					{
						name: 'disabled',
						label: 'Disabled',
						options: {
							customBodyRender: (value) => {
								return (
									<Link
										onClick={() => setActiveStatus('DISABLED')}
										style={{ cursor: 'pointer' }}
									>
										{value}
									</Link>
								);
							},
						},
					},
					{
						name: 'cards_value',
						label: 'Card value',
						options: {
							filter: true,
							sort: false,
						},
					},
				]}
				options={{
					filterType: 'checkbox',
				}}
			/>
			<Dialog
				open={!!activeStatus}
				onClose={() => setActiveStatus(null)}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				fullScreen
				style={{ marginTop: 100 }}
				fullWidth
			>
				<DialogTitle id='alert-dialog-title'>{'Detailed Accounts'}</DialogTitle>
				<DialogContent>
					{loadingAccounts && <LinearProgress />}
					<MUIDataTable
						options={{
							filterType: 'checkbox',
						}}
						data={accounts}
						title={'Card Status'}
						columns={[
							{
								name: 'first_name',
								label: 'Customer first name',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'last_name',
								label: 'Customer last name',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'account_number_formatted',
								label: 'Account Number',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'serial_number',
								label: 'Serial number',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'phone_number',
								label: 'Phone number',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'current_balance',
								label: 'Balance',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'wallet_type',
								label: 'Wallet Type',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'status',
								label: 'Status',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
						]}
					/>
				</DialogContent>
			</Dialog>
		</div>
	);
}

function Transactions({ startDate, endDate }) {
	const authUser = useAuthUser();

	const [transactionsLevel1, setTransactionsLevel1] = useState([]);
	const [activeStatus, setActiveStatus] = useState(null);
	const [transactions, setTransactions] = useState([]);

	const [loadingLevel1, setLoadingLevel1] = useState(false);
	const [loadingLevel2, setLoadingLeve2] = useState(false);

	useEffect(() => {
		const loyalCardsInstance = axios.create(
			new AdminService().getHeaders(authUser.token)
		);

		setLoadingLevel1(true);
		loyalCardsInstance
			.get(
				new FinanceService().COPMPANY_CARD_TRANSACTION +
					'?organization_id=' +
					authUser.organization.organization_id+"&start_date="+startDate.value+"&end_date="+endDate.value
			)
			.then((res) => {
				setTransactionsLevel1(transformCardData2(res.data.data));
			})
			.finally(() => {
				setLoadingLevel1(false);
			});
	}, [startDate, endDate]);

	useEffect(() => {
		if (!activeStatus) return;

		const status = activeStatus == 'ALL' ? '' : activeStatus;

		const loyalCardsInstance = axios.create(
			new AdminService().getHeaders(authUser.token)
		);

		setLoadingLeve2(true);
		loyalCardsInstance
			.get(
				new FinanceService().COPMPANY_CARD_TRANSACTIONS +
					'?organization_id=' +
					authUser.organization.organization_id +
					'&payment_mode=' +
					status +
					'&per_page=' +
					transactionsLevel1[0].total +
					"&start_date="+startDate.value+"&end_date="+endDate.value
			)
			.then((res) => {
				setTransactions(res.data.data);
			})
			.finally(() => {
				setLoadingLeve2(false);
			});
	}, [activeStatus, startDate, endDate]);

	return (
		<div>
			{loadingLevel1 && <LinearProgress />}
			<MUIDataTable
				title={'Transactions'}
				data={transactionsLevel1}
				columns={[
					{
						name: 'card',
						label: 'Card',
						options: {
							filter: true,
							sort: false,
							customBodyRender: (value) => {
								return (
									<Link
										onClick={() => setActiveStatus('CARD')}
										style={{ cursor: 'pointer' }}
									>
										{value}
									</Link>
								);
							},
						},
					},
					{
						name: 'topup',
						label: 'Topup',
						options: {
							customBodyRender: (value) => {
								return (
									<Link
										onClick={() => setActiveStatus('TOPUP')}
										style={{ cursor: 'pointer' }}
									>
										{value}
									</Link>
								);
							},
						},
					},
					{
						name: 'promotion',
						label: 'Promotion',
						options: {
							customBodyRender: (value) => {
								return (
									<Link
										onClick={() => setActiveStatus('PROMOTION')}
										style={{ cursor: 'pointer' }}
									>
										{value}
									</Link>
								);
							},
						},
					},
					{
						name: 'total',
						label: 'Total',
						options: {
							customBodyRender: (value) => {
								return (
									<Link
										onClick={() => setActiveStatus('')}
										style={{ cursor: 'pointer' }}
									>
										{value}
									</Link>
								);
							},
						},
					},
				]}
				options={{
					filterType: 'checkbox',
				}}
			/>
			<Dialog
				open={!!activeStatus}
				onClose={() => setActiveStatus(null)}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				fullScreen
				style={{ marginTop: 100 }}
				fullWidth
			>
				<DialogTitle id='alert-dialog-title'>
					{'Detailed Transactions'}
				</DialogTitle>
				<DialogContent>
					{loadingLevel2 && <LinearProgress />}
					<MUIDataTable
						data={transactions}
						title={'Transactions'}
						columns={[
							{
								name: 'agent',
								label: 'Agent',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'amount',
								label: 'Amount',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'payment_mode',
								label: 'Payment mode',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'plate_number',
								label: 'Plate number',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'route_name',
								label: 'Route name',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'tx_date',
								label: 'Tx date',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
							{
								name: 'tx_time',
								label: 'Tx time',
								options: {
									customBodyRender: (value) => value || 'N/A',
								},
							},
						]}
					/>
				</DialogContent>
			</Dialog>
		</div>
	);
}

function LoyalCustomerReport(props) {
	const [filterDialog,setFilterDialog]=useState(false);
	const [startDate,setStartDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
	const [endDate,setEndDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});

   const classes = useStyles();

   const [value, setValue] = React.useState(0);

		const handleChange = (event, newValue) => {
			setValue(newValue);
		};
  
  return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div className={classes.root}>
				<Box sx={{ width: '100%' }}>
					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							onClick={() => setFilterDialog(true)}
							color='primary'
							variant='contained'
						>
							Filter
						</Button>
					</div>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label='basic tabs example'
						>
							<Tab label='Card Status' id='1' />
							<Tab label='Transactions' id='2' />
						</Tabs>
					</Box>
					<CustomTabPanel value={value} index={0}>
						<CardStatus {...{ startDate, endDate }} />
					</CustomTabPanel>
					<CustomTabPanel value={value} index={1}>
						<Transactions {...{ startDate, endDate }} />
					</CustomTabPanel>
				</Box>
				<Dialog
					maxWidth='sm'
					fullWidth
					open={filterDialog}
					onClose={() => {
						setFilterDialog(true);
					}}
					aria-labelledby='filter'
					aria-describedby='filter'
				>
					<DialogTitle id='filter'>{'Filter'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant='inline'
										format='yyyy-MM-dd'
										margin='dense'
										autoOk
										label='Start date'
										value={startDate.value}
										inputVariant='outlined'
										onChange={(v) => {
											setStartDate({
												value: Format(v, ['yyyy-MM-dd']),
												error: '',
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant='inline'
										format='yyyy-MM-dd'
										margin='dense'
										autoOk
										label='End date'
										value={endDate.value}
										inputVariant='outlined'
										onChange={(v) => {
											setEndDate({
												value: Format(v, ['yyyy-MM-dd']),
												error: '',
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>

					<DialogActions>
						<Button
							onClick={() => {
								setFilterDialog(false);
							}}
						>
							<Typography>Apply</Typography>
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</MuiPickersUtilsProvider>
	);
}

export default withLocalize(LoyalCustomerReport);
